import { isCreditCard, Payment } from '@spa/store/modules/orderConfirm/types'
import CreditPaymentParamBuilder from './creditcardPaymentParamBuilder'

export interface PaymentParamBuilder {
  /**
   * Engine APIのI/Fに直接渡せるように、支払い方法設定を文字列に変換する
   *
   * Front側ではバリデーション等での取り扱いの観点から、基本的に文字列ではなくJSONで扱って、
   * Engineリクエストの時だけ文字列化する形にしたい.
   *
   * まずは buildAsJson といったメソッドを追加して、独自APIでは文字列を使わずJSONを使うようにして、
   * 最終的には全て buildAsJson を使って `build(): string` を削除したい.
   */
  build(): string
}

/**
 * @deprecated 原則ParametersBuilderを利用すること
 * 2024/12時点でクレジットカードでのみ利用される
 */
export function createPaymentParamBuilder(payment: Payment): PaymentParamBuilder {
  if (isCreditCard(payment)) {
    return new CreditPaymentParamBuilder(payment)
  }

  throw new Error(`This method is available only for credit card!`)
}
